import { render, staticRenderFns } from "./product-type.vue?vue&type=template&id=2d978c01&scoped=true&lang=html&"
import script from "./product-type.vue?vue&type=script&lang=js&"
export * from "./product-type.vue?vue&type=script&lang=js&"
import style0 from "./product-type.vue?vue&type=style&index=0&id=2d978c01&lang=scss&scoped=true&"
import style1 from "./product-type.vue?vue&type=style&index=1&lang=scss&module=skuMain&"




function injectStyles (context) {
  
  this["skuMain"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2d978c01",
  null
  
)

export default component.exports